import styled from "@emotion/styled";
import { FC } from "react";
import { FieldInputProps } from "react-final-form";

import { DesignToken, Icon, SpacingToken, Text } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

import { ACTION_ICON, ACTION_NAME } from "../components/constants";

import { ActionFieldArrayElement } from "./interfaces";
import { ActionLabel } from "./parts/ActionLabel";
import { mapActionToActionType } from "./utils";

interface IProps {
  input: FieldInputProps<ActionFieldArrayElement>;
}

export const ActionAccordionLabel: FC<IProps> = ({ input }) => {
  const actionType = mapActionToActionType(input.value);

  if (!actionType) {
    return null;
  }

  return (
    <Container>
      <ActionIcon source={ACTION_ICON[actionType]} customColor={withVar(DesignToken.ContentBasicSecondary)} />
      <LabelContainer>
        <ActionName bold>{ACTION_NAME[actionType]}</ActionName>
        <ActionLabel input={input} />
      </LabelContainer>
    </Container>
  );
};

const ActionIcon = styled(Icon)`
  margin-top: ${withVar(SpacingToken.Spacing05)};
  align-self: flex-start;
`;

const ActionName = styled(Text)`
  margin-left: var(${SpacingToken.Spacing1});
  white-space: nowrap;
`;

const Container = styled.div`
  display: flex;
  gap: ${withVar(SpacingToken.Spacing1)};
`;

const LabelContainer = styled(Container)`
  flex-wrap: wrap;
  align-items: center;
`;
